// IE 2026 10 13 / ODOO-5800 (бой 13.10 09:42:32 и 12.10 06:23: тело сохранения записи 5 МБ дошло до бэка обрезанным): бэк отвечал HTTP 200 с уведомлением
// critical и без status:'error' — saveRecord снимал _meta.modified, кнопка Save гасла, правки терялись молча. Теперь решение «сохранено ли» — здесь:
//   НЕ сохранено — HTTP ≥ 400 (ветка error: $.ajax; бэк на обрезанное тело отвечает 400 {status:'error', code:'body_truncated'}), status === 'error',
//   уведомление critical без id в ответе (исключение бэка до записи); modified остаётся, текст ошибки показывается;
//   повтор — ОДИН, через 2 с: code === 'body_truncated' (запрос не обработан — повтор безопасен) или обрыв / отмена без ответа (status 0, не timeout).
// Флаг fe.ux.saveTruncatedRetry (дефолт ВКЛ; нет читателя / ошибка — ВКЛ); выкл — как было (только status === 'error' считается несохранённым, без повтора).
// Чистая логика — юнит tests/unit/saveOutcome.test.mjs
export const SAVE_TRUNCATED_RETRY_FLAG = 'fe.ux.saveTruncatedRetry'   // IE 2026 10 13 / ODOO-5800
export const SAVE_RETRY_DELAY_MS = 2000   // IE 2026 10 13 / ODOO-5800
export const SAVE_RETRY_MAX = 1   // IE 2026 10 13 / ODOO-5800

export function saveTruncatedRetry_on(setting) {   // IE 2026 10 13 / ODOO-5800: чтение флага (нет читателя / ошибка — ВКЛ)
    try { return typeof setting === 'function' ? setting(SAVE_TRUNCATED_RETRY_FLAG, true) !== false : true } catch (e) { return true }
}

// Ответ успешной ветки $.ajax (HTTP 2xx) → { saved, retry, text }
export function saveOutcome_answer(answer, { on = true, attempt = 0 } = {}) {   // IE 2026 10 13 / ODOO-5800
    const a = answer && typeof answer === 'object' ? answer : {}
    if (a.status === 'error') {
        return { saved: false, retry: !!on && a.code === 'body_truncated' && attempt < SAVE_RETRY_MAX, text: a.error || '' }
    }
    if (!on) return { saved: true, retry: false, text: '' }
    const ntf = a.notification && typeof a.notification === 'object' ? a.notification : null
    if (ntf && ntf.status === 'critical' && !a.id) {
        return { saved: false, retry: false, text: ntf.text || '' }
    }
    return { saved: true, retry: false, text: '' }
}

// Ветка error $.ajax (jqXHR, textStatus) → { saved: false, retry, text } — HTTP ≥ 400 или сеть; текст — error из тела ответа бэка, если есть
export function saveOutcome_error(jqXHR, textStatus, { on = true, attempt = 0 } = {}) {   // IE 2026 10 13 / ODOO-5800
    const x = jqXHR || {}
    let body = x.responseJSON
    if (!body && typeof x.responseText === 'string' && x.responseText.trim().startsWith('{')) {
        try { body = JSON.parse(x.responseText) } catch (e) { body = null }
    }
    const status = Number(x.status) || 0
    let text = (body && typeof body.error === 'string' && body.error) || ''
    if (!on) return { saved: false, retry: false, text: '' }
    const truncated = !!body && body.code === 'body_truncated'
    // IE 2026 10 13 / ODOO-5800 (app7: nginx 499 — запрос оборвал сам клиент): обрыв / отмена без ответа (status 0, кроме timeout) — «Save interrupted — not saved», повтор
    const interrupted = status === 0 && textStatus !== 'timeout'
    if (interrupted && !text) text = SAVE_INTERRUPTED_TEXT
    return { saved: false, retry: (truncated || interrupted) && attempt < SAVE_RETRY_MAX, text }
}

// IE 2026 10 13 / ODOO-5800 (app7 13.10: POST /api/ 499 через 0,55 с — клиент оборвал крупный запрос в те же секунды, что workspace_applySelector / widget_open):
// запрос в полёте виджета (WIDGET._activeRequest) обрывался ЛЮБЫМ следующим executeWidgetMethod того же виджета («previous request cancelled» + del_last_backend_action
// бэку) и тихим стопом страницы (widget_stopLoading: pageFocus / Stop), а ветка error на textStatus 'abort' молча выходила — сохранение (method 'save' сетки, вставка,
// импорт) пропадало без следа. Запись (request_isWrite) больше не обрывается и не отменяется на бэке (abort_allowed); флаг тот же — fe.ux.saveTruncatedRetry.
export const SAVE_INTERRUPTED_TEXT = 'Save interrupted — not saved'   // IE 2026 10 13 / ODOO-5800
const WRITE_METHODS = new Set(['save', 'pasteItems', 'importItems', 'pasteWidget', 'importWidget', 'delete_Click'])   // IE 2026 10 13 / ODOO-5800

export function request_isWrite(action) {   // IE 2026 10 13 / ODOO-5800: запрос пишет данные (сохранение записи / сетки, вставка, импорт, удаление, save* методов)
    const a = action && typeof action === 'object' ? action : {}
    if (a._isPoll) return false
    if (a.command === 'saveRecord') return true
    if (a._gridSave === true) return true   // IE 2026 10 13 / ODOO-5800: Save полосы ленивого грида (saveMethod любого имени) — запись: в полёте не обрывается
    const m = typeof a.method === 'string' ? a.method : ''
    return WRITE_METHODS.has(m) || /save/i.test(m)
}

export function abort_allowed(jqXHR, on = true) {   // IE 2026 10 13 / ODOO-5800: можно ли оборвать запрос в полёте (запись в полёте — нельзя при флаге ВКЛ)
    return !(on && jqXHR && jqXHR._isWrite && jqXHR.readyState !== 4)
}
